import Cookies from 'js-cookie';
import {
    BALLOT_BASKET_STORAGE_KEY,
    BALLOT_RESERVED_PRODUCTS_STORAGE_KEY,
    BALLOT_ORDER_FILE_NUMBER_COOKIE_NAME
} from './constants';

export default class BasketProductsHelper {
    static setSecutixReservedProducts(secutixBallotReservedProducts) {
        if (localStorage) {
            this.getCookie(BALLOT_ORDER_FILE_NUMBER_COOKIE_NAME) !== '' ? this.addReservedProductsToBallotProductsList(secutixBallotReservedProducts) :
                this.removeReservedProductsFromBallotProductsList();
        }
    }

    static addReservedProductsToBallotProductsList(secutixBallotReservedProducts) {
        if (Object.keys(secutixBallotReservedProducts).length !== 0) {
            const ballotBasketReservedProducts = {};

            secutixBallotReservedProducts.forEach((element) => {
                ballotBasketReservedProducts[element.id] = element;
            });

            if (localStorage.getItem(BALLOT_BASKET_STORAGE_KEY) === null) {
                localStorage.setItem(BALLOT_BASKET_STORAGE_KEY, JSON.stringify(ballotBasketReservedProducts));
                localStorage.setItem(BALLOT_RESERVED_PRODUCTS_STORAGE_KEY, JSON.stringify(ballotBasketReservedProducts));
            } else if (localStorage.getItem(BALLOT_RESERVED_PRODUCTS_STORAGE_KEY) === null) {
                const ballotBasket = JSON.parse(localStorage.getItem(BALLOT_BASKET_STORAGE_KEY));

                secutixBallotReservedProducts.forEach((element) => {
                    if (!ballotBasket.hasOwnProperty(element.id)) {
                        ballotBasket[element.id] = element;
                    }
                });

                localStorage.setItem(BALLOT_BASKET_STORAGE_KEY, JSON.stringify(ballotBasket));
                localStorage.setItem(BALLOT_RESERVED_PRODUCTS_STORAGE_KEY, JSON.stringify(ballotBasketReservedProducts));
            }
        }
    }

    static removeReservedProductsFromBallotProductsList() {
        if (!this.isBallotLocalStorageEmpty()) {
            const basketBallot = JSON.parse(localStorage.getItem(BALLOT_BASKET_STORAGE_KEY));
            const secutixBallotProducts = JSON.parse(localStorage.getItem(BALLOT_RESERVED_PRODUCTS_STORAGE_KEY));
            const secutixBallotProductsList = [];

            for (const product in secutixBallotProducts) { secutixBallotProductsList.push(secutixBallotProducts[product]); }

            secutixBallotProductsList.forEach((element) => {
                if (basketBallot.hasOwnProperty(element.id)) {
                    delete basketBallot[element.id];
                }
            });

            localStorage.removeItem(BALLOT_RESERVED_PRODUCTS_STORAGE_KEY);
            localStorage.setItem(BALLOT_BASKET_STORAGE_KEY, JSON.stringify(basketBallot));
        }
    }

    static isBallotLocalStorageEmpty() {
        if (localStorage.getItem(BALLOT_RESERVED_PRODUCTS_STORAGE_KEY) !== null &&
            localStorage.getItem(BALLOT_BASKET_STORAGE_KEY) !== null) { return false; }

        return true;
    }

    static getCookie(cookieName) {
        const cookie = Cookies.get(cookieName);
        return cookie && cookie !== '0' ? cookie : '';
    }
}
